<script>
	import {
		openTokenDepositModal,
		openTokenWithdrawModal
	} from '$lib/home/userInteract/userInteract';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import ScAutoConfig from '../utils/SCAutoConfig.svelte';
	import ScInfo from '../utils/SCInfo.svelte';
	import MarketMargins from './MarketMargins.svelte';
	import TokenBalance from './TokenBalance.svelte';
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-2xl"
	outerClassList=""
	innerClassList="flex justify-center items-center bg-fx-black"
>
	<div class="bg-fx-gradient-8-40 sm:p-6 p-4 w-full rounded-2xl h-full">
		<div class="flex justify-between items-center">
			<div class="text-fx-gradient-5 font-semibold text-2xl">Wallet</div>
			<div class="flex gap-2">
				<button
					class="px-4 py-2 text-fx-grey-200 text-xs border border-fx-grey-500 bg-fx-gradient-8 rounded-lg squircle-lg"
					on:click={() => {
						openTokenDepositModal();
					}}
					on:keydown={() => {
						openTokenDepositModal();
					}}
				>
					Deposit
				</button>
				<button
					class="px-4 py-2 text-fx-grey-200 text-xs border border-fx-grey-500 bg-fx-gradient-8 rounded-lg squircle-lg"
					on:click={() => {
						openTokenWithdrawModal();
					}}
					on:keydown={() => {
						openTokenWithdrawModal();
					}}
				>
					Withdraw
				</button>
				<!-- <div
					class="px-4 py-2 text-fx-grey-200 text-xs border border-fx-grey-500 bg-fx-gradient-8 rounded-lg squircle-lg"
				>
					Swap
				</div>
				<div
					class="px-4 py-2 text-fx-grey-200 text-xs border border-fx-grey-500 bg-fx-gradient-8 rounded-lg squircle-lg"
				>
					Transfer Margin
				</div> -->
			</div>
		</div>

		<div class="border-t border-t-fx-grey-600 my-3" />

		<GradientBorder
			gradient="bg-fx-gradient-6"
			paddingClass="p-px"
			borderRadius="rounded-lg"
			outerClassList="mb-3"
			innerClassList="flex justify-between items-center bg-fx-gradient-8 w-full px-3 py-2"
		>
			<div class="flex items-center">
				<img class="w-8 h-8" src={'new_sc_wallet/op_stars.svg'} loading="lazy" alt="op-stars" />
				<p class="text-xs text-fx-gradient-25">Claim OP from competitions & trading season.</p>
			</div>

			<Tooltip
				header="Claim OP rewards"
				title="OP rewards both Synthetix and Polynomial boosted ones get deposited in your Smart Wallet"
			>
				<button
					class="text-fx-pink text-xs underline-offset-4 underline"
					on:click={() => {
						openTokenWithdrawModal('OP');
					}}
					on:keydown={() => {
						openTokenWithdrawModal('OP');
					}}>Claim OP</button
				>
			</Tooltip>
		</GradientBorder>
		<div class="grid grid-cols-2 gap-2.5">
			<TokenBalance />
			<MarketMargins />
		</div>
		<div class="border-t border-t-fx-grey-600 my-3" />

		<ScAutoConfig size="xs" />
		<div class="border-t border-t-fx-grey-600 my-3" />

		<ScInfo size="xs" />
	</div>
</GradientBorder>
